<app-bread-crumb [items]="[{text:  'utilizadores',link:'/admin/users'},{text:pageTitle}]" [sectionTitle]="pageTitle">
</app-bread-crumb>


<section class="content">

    <!-- fim do conteudo -->
    <form [formGroup]="objectForm" novalidate (ngSubmit)="submitForm()">

        <ng-box [boxIcon]="'fa fa-user'" [boxTitle]="'Dados do Utilizador'" [showBoxFooter]="true">

            <!-- cabesalho -->
            <ng-container class="ng-box-header">
                <ng-button (click)="back()" [button]="{name:'back',faIconClass:'fa fa-arrow-left',color:'secondary'}">
                </ng-button>
            </ng-container>

            <!-- inicio do conteudo -->
            <ng-container class="ng-box-content">

                <div class="row">

                    <div class="col-md-6">

                        <div class="form-group">

                            <app-input label="Nome(*)" errorMessage="Campo obrigatório">
                                <input type="text" formControlName="name" class="form-control">
                            </app-input>

                        </div>

                    </div>

                    <div class="col-md-6">

                        <div class="form-group">

                            <app-input label="BI(*)" errorMessage="- Campo obrigatório; - Maxímo 13 digítos;">
                                <input type="text" formControlName="bi" class="form-control">
                            </app-input>

                        </div>

                    </div>

                </div>

                <div class="row">

                    <div class="col-md-6">

                        <div class="form-group">

                            <app-input label="Nuit(*)" errorMessage="- Campo obrigatório; - Máximo 12 digítos">
                                <input type="text" formControlName="nuit" class="form-control">
                            </app-input>

                        </div>

                    </div>


                    <!-- <div class="col-md-6">


                        <div class="form-group">

                            <app-input label="Foto" errorMessage="Campo obrigatório">
                                <div class="upload-btn-wrapper">
                                    <button class="btn btn-outline-danger btn-block">
                                        <i class="fa fa-cloud-upload"> Selecione uma imagem</i>
                                    </button>
                                    <small class="text-primary">{{ iptFile?.files[0]?.name }}</small>
                                    <input #iptFile type="file" #img formControlName="pic">
                                </div>

                            </app-input>

                        </div>

                    </div> -->

                    <div class="col-md-6">

                        <div class="form-group">

                            <app-input label="Telefone(*)"
                                errorMessage="- Campo obrigatório; Maxímo 14 Digítos; - Introduza telefone válido">
                                <input type="text" formControlName="phone" class="form-control">
                            </app-input>

                        </div>

                    </div>
                </div>
                <div class="row">

                    <div class="col-md-6">

                        <div class="form-group">

                            <app-input label="Perfil(*)" errorMessage="Campo obrigatório">

                                <select formControlName="role_id" class="form-control" #iptPerfil>
                                    <option *ngFor="let role of roles" [value]="role.id">{{role.description}}</option>
                                </select>

                            </app-input>

                        </div>

                    </div>
                    <div class="col-md-6">

                        <div class="form-group">

                            <app-input label="Endereço(*)" errorMessage="Campo obrigatório">
                                <input type="text" formControlName="address" class="form-control">
                            </app-input>

                        </div>

                    </div>

                </div>


                <!-- <div class="row">
              <div class="col-md-12">
                
                <div class="form-group">

                  <app-input label="Perfil(*)" errorMessage="Campo obrigatório">
                    <select formControlName="role_id" class="form-control">
                      <option value="">Selecione o Tipo de Utilizador</option>
                      <option value="khuzela">Selecione o Tipo de Utilizador</option>
                      <option value="Clube">Selecione o Tipo de Utilizador</option>
                    </select>
                  </app-input>

                </div>

              </div>
            </div> -->
                <fieldset *ngIf="iptPerfil.value==2 || iptPerfil.value==4">
                    <legend>Dados de Representante</legend>
                </fieldset>

                <div class="row" *ngIf="iptPerfil.value==2 || iptPerfil.value==4">

                    <div class="col-md-4">

                        <div class="form-group">

                            <app-input label="Nome" errorMessage="Campo obrigatório">
                                <input type="text" formControlName="responsible_name" class="form-control">
                            </app-input>

                        </div>

                    </div>

                    <div class="col-md-4">

                        <div class="form-group">

                            <app-input label="Telefone" errorMessage="Campo obrigatório">
                                <input type="text" formControlName="responsible_phone" class="form-control">
                            </app-input>

                        </div>

                    </div>
                    <div class="col-md-4">

                        <div class="form-group">

                            <app-input label="Clube" errorMessage="Campo obrigatório">
                                <select formControlName="clubs_id" class="form-control">
                                    <option value="">Selecione o Clube</option>
                                    <option *ngFor="let club of clubs" [value]="club.id">{{club.name}}</option>
                                </select>
                            </app-input>

                        </div>


                    </div>

                </div>
                <fieldset>
                    <legend>Dados de Acesso</legend>
                </fieldset>
                <div class="row">

                    <div class="col-md-4">

                        <div class="form-group">

                            <app-input label="Email(*)"
                                errorMessage="- Campo obrigatório; - Introduza um email válido;">
                                <input type="text" formControlName="email" class="form-control">
                            </app-input>

                        </div>

                    </div>

                    <div class="col-md-4">

                        <div class="form-group">

                            <app-input label="Senha(*)" errorMessage="Campo obrigatório">
                                <input type="password" formControlName="password" class="form-control">
                            </app-input>

                        </div>

                    </div>
                    <div class="col-md-4">

                        <div class="form-group">

                            <app-input label="Confirmar Senha(*)" errorMessage="Campo obrigatório">
                                <input type="password" formControlName="confirmPassword" class="form-control">
                            </app-input>

                        </div>


                    </div>

                </div>

                <div class="row">
                    <div class="col-xs-12 col-sm-12">
                        <span class="help-block pull-right text-danger"
                            *ngIf="objectForm.hasError('passwordsNotMatch')"><i class="fa fa-remove"></i>Os
                            Passwords não Conferem</span>
                    </div>
                </div>

            </ng-container>
            <!-- fim do conteudo  -->

            <!-- inicio do footer -->
            <ng-container class="ng-box-footer">

                <div class="row">
                    <div class="col-xs-12">
                        <ng-button *ngIf="isAdmin()" class="pull-right" [button]="{
                            name:'salvar',
                            color:'danger',
                            faIconClass:'fa fa-save',
                            type:'submit',
                            loadingText:'SALVANDO',
                            isLoading:isButtonLoading,
                            isDisabled:isButtonLoading || objectForm.invalid}">
                        </ng-button>
                    </div>
                </div>
            </ng-container>
            <!-- fim do footer -->

        </ng-box>

        <!-- fim do box -->

    </form>
    <!-- fim do form -->

</section>